import { HttpClient } from "@angular/common/http";
import {
  Component,
  OnDestroy,
  OnInit,
  ViewChild,
  AfterViewInit,
  Output,
  EventEmitter,
} from "@angular/core";
import { DataTableDirective } from "angular-datatables";
import { IOption } from "ng-select";
import { AuthenticationService } from "../../services/authentication.service";
import { ActivatedRoute } from "@angular/router";
import { Subject } from "rxjs/Subject";
import { DmsAccessService } from "../../services/dms-access.service";
import { DownloadService } from "../../services/download.service";
import { HelperService } from "../../services/helper.service";
import { TosterMessageService } from "../../services/toster-message.service";
import { BsModalRef } from "ngx-bootstrap/modal/bs-modal-ref.service";
import { BsModalService } from "ngx-bootstrap/modal";
import { NgxSpinnerService } from "ngx-spinner";
import { ConfigurationService } from "../../services/configuration.service";
import { ObjectivesService } from "../../services/objectives.service";
import { NavigationCompanyAssignService } from "../../services/navigation-company-assign.service";
import { RilrService } from "../../services/rilr.service";

@Component({
  selector: "app-approval-roles-master-edit-modal.component",
  templateUrl: "./approval-roles-master-edit-modal.component.html",
  providers: [
    ConfigurationService,
    DownloadService,
    DmsAccessService,
    ObjectivesService,
    NavigationCompanyAssignService,
    RilrService,
  ],
})
export class ApprovalRoleMasterEditModalComponent implements OnInit {
  toolTipHtml: string;
  dtOptions: any = {};
  @ViewChild(DataTableDirective)
  dtElement: DataTableDirective;
  dtTrigger: Subject<any> = new Subject();
  userAccess: any;
  isFilterEnabled: boolean = false;
//   public bsModalRefLocation: BsModalRef;
  @ViewChild("swalModalNotAccess") swalModalNotAccess: any;
  @ViewChild("swalModalDeleteDesignation") swalModalDeleteDesignation: any;
  @ViewChild("errorMessageHtml") errorMessageHtml: any;
  @ViewChild("swalModalDeleteElementMaster") swalModalDeleteElementMaster: any;
  @ViewChild("swalModalDeleteProficiencyMaster")
  swalModalDeleteProficiencyMaster: any;

  notAccessAlertOpen() {
    this.swalModalNotAccess.show();
  }

  message: string = "";
  public htmlErrorMessage: string = "";

  items: any[];
  totalRec: Number;
  orderCondition: any;
  companySystemID = this.helperService.getSelectedCompanyId();

  @Output() tableReload: EventEmitter<any> = new EventEmitter();
  public userGroupCompany: Array<IOption> = [];
  @ViewChild("swalModalDeleteRole") swalModalDeleteRole: any;

  public masterData: Array<IOption> = [];
  public moduleList: Array<IOption> = [];
  public roleStatus: Array<IOption> = [];
  auto_id: number;

  constructor(
    private tosterMessageService: TosterMessageService,
    private authenticationService: AuthenticationService,
    private route: ActivatedRoute,
    private spinner: NgxSpinnerService,
    public bsModalRef: BsModalRef,
    private modalService: BsModalService,
    private helperService: HelperService,
    private configurationService: ConfigurationService,
    private objectivesService: ObjectivesService,
    private navigationCompanyAssignService: NavigationCompanyAssignService,
    private rilrService: RilrService
  ) {}

  closeModal() {
    this.bsModalRef.hide();
    this.modalService.setDismissReason("questionbank_closed");
  }

  closeModalAfterCreate() {
    this.bsModalRef.hide();
    this.modalService.setDismissReason("questionbank_closed");
  }


  ngOnInit() {
    console.log(this.auto_id);
    console.log(this.masterData);
    console.log(this.moduleList);
    console.log(this.roleStatus);
  }



  getRoleStatusPlaceholder(role_status: number): string {
    return role_status === 1 ? 'Active' : 'Not Active';
  }



  updateRoleMaster() {
    // this.spinner.show();
    let that = this;
    const requestData = {
      auto_id: that.auto_id,
      masterData: that.masterData,
    };
    console.log(requestData);

    that.objectivesService
      .updateRoleMaster()
      .post(requestData)
      .subscribe(
        (resp: any) => {
          console.log(resp);
          this.tosterMessageService.showSuccess(
            "Success",
            "Role Master Successfully Updated."
          );
          that.closeModalAfterCreate();
          this.tableReload.emit();
          this.spinner.hide();
        },
        (error) => {
          console.log(error);
          this.tosterMessageService.showError("Sorry","Invalid input!.");
          that.closeModalAfterCreate();
          this.spinner.hide();
        }
      );
    this.tableReload.emit();
  }



}



// WEBPACK FOOTER //
// /app/src/app/configuration/approval-roles-master-edit-modal/approval-roles-master-edit-modal.component.ts